import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components';
import styles from 'styles/actions_buttons.module.scss';
import useHover from 'hooks/useHover';
import { useResponsive } from 'react-hooks-responsive'


const ActionsButtons = ({ item, actions }) => {
	const [collapsed, setCollapsed] = useState(true);
	const getProperValue = (value, item) => (typeof value === 'function' ? value(item) : value);
	const button_ref = useRef(null);
	const actions_ref = useRef(null);
	const breakpoints = { xs: 0, sm: 1045, md: 1200 }
	const { size, orientation, screenIsAtLeast, screenIsAtMost } = useResponsive(breakpoints)

	// useEffect(() => {
	// 	document.addEventListener('click', handleClick, false);
	// 	return () => {
	// 		document.removeEventListener('click', handleClick, false);
	// 	};
	// }, [collapsed]);

	// const handleClick = event => {
	// 	const node = button_ref.current;
	// 	if (!node) return;
	// 	if (node.contains(event.target)) {
	// 		//click inside the button
	// 		return setCollapsed(!collapsed); //toggle
	// 	}
	// 	//click outside the button
	// 	setCollapsed(true); //close
	// 	return true;
	// };

	return (
		<div
			className={styles.actions}
			ref={actions_ref}
		>
			<div
				className={styles.actions_wrapper}
				data-collapsed={collapsed}
				data-popover={screenIsAtMost('sm')}
				onMouseEnter={() => setCollapsed(false)}
				onMouseLeave={() => setCollapsed(true)}
			>
				{screenIsAtMost('sm') && <Button
					className={styles.action_button_menu}
					icon="ellipsis-v"
					react_ref={button_ref}
					type="circle-secondary"
					style={{ margin: '7px', flexShrink: 0 }}
				/>}
				{(screenIsAtMost('sm') ? !collapsed : true) && (
					<div>
						{actions.map((action, key) => {
							return (
								<Button
									className={styles.action_button}
									key={key}
									icon={getProperValue(action.icon, item)}
									id={item.id}
									onClick={() => action.method(item)}
									type={`circle-${getProperValue(action.color, item)}`}
									style={{ margin: '7px' }}
									disabled={getProperValue(action.disabled,item)}
								/>
							);
						})}
					</div>
				)}
			</div>
		</div>
	);
};

ActionsButtons.propTypes = {};

export default ActionsButtons;
